module.exports = __webpack_public_path__ + "static/img/product-anti-fraud.8b9bf753.png";